export default "__VITE_ASSET__16659d9d__"